import { create } from 'zustand'

export const useUiStore = create((set) => ({
  sidebarOpen: false,           // mobile drawer
  setSidebarOpen: (v) => set({ sidebarOpen: v }),
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
}))
